import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'
import Footer from './Footer'
import _ from 'lodash'

export default class extends BaseComponent {

  render () {
    const page = _.filter(this.props.data.pages, { slug: this.props.location.pathname })[0]

    return (
      <section className="generic-page">
        <ul className="breadcrumbs">
          <div className="container-big">
            <li><NavLink to="/">Strona główna</NavLink></li>
            <li><NavLink to={ page.slug }>{ page.additional_fields.pageTitle }</NavLink></li>
          </div>
          <div className="bottom"></div>
        </ul>
        <div className="container">
          <h1 dangerouslySetInnerHTML={{ __html: this.addColor(page.additional_fields.pageTitle) }}></h1>
        </div>
        <div className="container">
          <div className="content" dangerouslySetInnerHTML={{ __html: page.additional_fields.content }}></div>
        </div>
        <Footer data={ this.props.data } settings={ this.props.data.settings }/>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/GenericPage.js